import React from 'react'; 
import {useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {Box, CircularProgress, FormHelperText, IconButton, MenuItem, TextField} from "@mui/material";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal, toggleLoading} from "../../../state/ModalSlice/ModalSlice.ts";
import {createRazorpayAccountRoute, logAction} from "../utilityFunctions.ts";
import {toast} from "react-toastify";
import {useBackend} from "../../../hooks/backend/useBackend.ts";
import CloseIcon from "@mui/icons-material/Close";
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';    
import { Timestamp } from 'firebase/firestore';
import { ActionType } from '../../../enums.ts';
export default function AddBankAccountModal() {

    // ------------------------DialogHandlers

    const Dispatch = useAppDispatch();
    const open = useSelector((state: RootState) => state.ModalSlice.AddBankAccountOpen);

    const handleClose = () => {
        Dispatch(closeModal("AddBankAccountOpen"))
        resetForm()
    };
    const businessName = useAppSelector((state) => {
        return state.userSliceV2.data?.businessProfile?.businessName||""
    })

    useEffect(() => {
        if (businessName) {
            setBusinessName(businessName);
        }
    }, [businessName]);


    // ------------------------Form States
    const [bankAccountNumber, setBankAccountNumber] = React.useState<string>("")
    const [IFSCCode, setIFSCCode] = React.useState<string>("")
    const [BusinessName, setBusinessName] = React.useState<string>(businessName ? businessName : "")
    const [Name, setName] = React.useState<string>("")
    const [businessType, setBusinessType] = React.useState<number>(3)  //Storing the index which can be later used for retrieving
    const [AccountType, setAccountType] = React.useState<number>(0)
    const [panNumber, setPanNumber] = React.useState<string>("")

    const [, setIsError] = React.useState<boolean>(false)

    const [submissionError, setSubmissionError] = React.useState<boolean>(false)

    // ------------------------Reset States
    const resetForm = () => {
        setBankAccountNumber("");
        setIFSCCode("");
        setBusinessName(businessName ? businessName : "");
        setName("");
        setBusinessType(3);
        setAccountType(0);
        setIsError(false);
        setModalError({
            Name: false,
            BusinessName: false,
            IFSCCode: false,
            bankAccountNumber: false,
            panNumber: false
        });
        setSubmissionError(false)
    };

    // ------------------------Handle Change Form States


    const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value)
    }

    const handleChangeBusinessName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBusinessName(event.target.value)
    }


    const handleChangebankAccountNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = event.target;

        for (let i = 0; i < value.length; i++) {

            const char = value[i];
            if (char >= '0' && char <= '9') { /* empty */
            } else {
                return;
            }
        }

        setBankAccountNumber(value)
    }


    const handleChangeIFSCCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIFSCCode(event.target.value)
    }


    const handleChangeBusinessType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBusinessType(Number(event.target.value))
    }

    const handleChangeAccountType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAccountType(Number(event.target.value))
    }

    const handleChangePanNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPanNumber(event.target.value.toUpperCase())
    }

    // ------------------------Error Handlers

    const [modalError, setModalError] = React.useState({
        Name: false,
        BusinessName: false,
        IFSCCode: false,
        bankAccountNumber: false,
        panNumber: false
    });

    function CheckErrors(): boolean {
        setIsError(false)
        let localerror: boolean = false

        if (Name.trim() === "") {
            setIsError(true)
            localerror = true
            setModalError((prev) => {
                return {...prev, Name: true}
            })
        } else {

            setModalError((prev) => {
                return {...prev, Name: false}
            })
        }
        if (BusinessName.trim() === "") {
            setIsError(true)
            localerror = true
            setModalError((prev) => {
                return {...prev, BusinessName: true}
            })
        } else {

            setModalError((prev) => {
                return {...prev, BusinessName: false}
            })
        }
        if (bankAccountNumber.trim().length < 9) {
            localerror = true
            setIsError(true)
            setModalError((prev) => {
                return {...prev, bankAccountNumber: true}
            })
        } else {

            setModalError((prev) => {
                return {...prev, bankAccountNumber: false}
            })
        }
        if (IFSCCode.trim().length < 9) {
            localerror = true
            setIsError(true)
            setModalError((prev) => {
                return {...prev, IFSCCode: true}
            })
        } else {

            setModalError((prev) => {
                return {...prev, IFSCCode: false}
            })
        }
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panRegex.test(panNumber)) {
            localerror = true
            setIsError(true)
            setModalError((prev) => {
                return {...prev, panNumber: true}
            })
        } else {
            setModalError((prev) => {
                return {...prev, panNumber: false}
            })
        }

        return localerror

    }


    // --------------------------Form Options


    const BusinessTypeOptions: string[] = [
        "llp",
        "ngo",
        "other",
        "individual",
        "partnership",
        "proprietorship",
        "public_limited",
        "private_limited",
        "not_yet_registered",
        "educational_institutes",
    ]

    const AccountTypeOptions: string[] = [
        "Saving", "Current"
    ]


    // --------------------------On Submit Operation

    const ServiceProviderID = useAppSelector(selectEffectiveUID) 
    const { uid: spId, display_name: spName } = useAppSelector((state: RootState) => state.userSliceV2?.data) || {}
    const {updateArrayField} = useBackend(`/ServiceProviders`)

    async function handleRazorpayAndBackendCall() {
        const reqDoc = {
            name: Name,
            business_name: BusinessName,
            business_type: BusinessTypeOptions[businessType],
            ifsc_code: IFSCCode,
            beneficiary_name: Name,
            account_type: AccountTypeOptions[AccountType],
            account_number: bankAccountNumber
        
        }
        Dispatch(toggleLoading(true))
        const response: any = await createRazorpayAccountRoute(reqDoc)

        if (response === "error") {
            setSubmissionError(true)
            Dispatch(toggleLoading(false))
            return
        } else {


            const hydratedData = {
                accountName: Name,
                accountNo: bankAccountNumber,
                iFSC: IFSCCode,
                razorpayAccountId: response.razorpayAccountId,
                razorpayAccountStatus: response.razorpayAccountStatus,
                PAN: panNumber

            }

            if (ServiceProviderID) {
                updateArrayField(ServiceProviderID, "paymentProfiles", hydratedData)
                toast.success("Bank Account Added Successfully")
                logAction({
                    action: ActionType.addBankAccount,
                    timestamp: Timestamp.now(),
                    platform: "web",
                    performedBy: {
                        spId: spId || "",
                        name: spName || ""
                    },
                    context: {
                        bankAccountNumber: bankAccountNumber,
                        accountName: Name,
                        ifsc: IFSCCode,
                        razorpayAccountId: response.razorpayAccountId,
                        razorpayAccountStatus: response.razorpayAccountStatus,
                        pan: panNumber
                    }
                }, ServiceProviderID)
            }
        }
        Dispatch(toggleLoading(false))
        handleClose()
        resetForm()

    }


    function onSubmit() {
        const Localerrors = CheckErrors()
        if (Localerrors) {

            return
        }
        handleRazorpayAndBackendCall()

    }


    // ----------------------Controlling Backdrop and Loadind state

    const isLoading: boolean = useAppSelector((state) => state.ModalSlice.isLoading)


    return (
        <React.Fragment>

            <Dialog
                maxWidth="md"
                fullWidth
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'div',

                }}
                sx={{
                    padding: 0,
                    '& .MuiPaper-root': {
                        borderRadius: '10px',
                        width: { xs: 'calc(100% - 32px)', sm: 'auto' },
                        maxWidth: { xs: 'calc(100% - 32px)', sm: '600px', md: '800px' },
                        minWidth: { sm: '600px', md: '800px' },
                        margin: { xs: '16px', sm: 'auto' },
                        maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' },
                        overflow: 'hidden',
                        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important'
                    },
                }}
            >

                <DialogContent sx={{paddingX: { xs: "16px", sm: "24px", md: "60px" }, paddingY: { xs: "24px", sm: "40px", md: "50px" }, maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }, minHeight: { sm: '20vh' }, overflowY: 'auto'}} className={"bg-white"}>
                    <div className={"header pb-3 sm:pb-[20px]"}>
                        <p className={"text-base sm:text-lg font-[600] "}>Add Bank Details</p>
                        <p className={"text-xs sm:text-sm font-[400] "}>Your bank details to receive payments</p>
                        {submissionError && <FormHelperText error={true}>
                            <span className={"w-full flex items-center text-xs sm:text-sm"}>An error occurred while adding your bank account. Please check your details and try again</span></FormHelperText>}
                    </div>
                    <div className={"absolute right-2 sm:right-4 top-2 sm:top-4"}><IconButton onClick={handleClose} size="small">
                        <CloseIcon fontSize="small"/>
                    </IconButton></div>
                    <div className={" "}>
                        <div className={""}>

                            <div className={"w-full"}>
                                <div className={"w-full max-w-full"}>
                                    <Box
                                        component={"div"}
                                        sx={{}}
                                    >
                                        <div className={"TextFields flex flex-col gap-4"}>
                                            <TextField
                                                onChange={handleChangeBusinessName}
                                                value={BusinessName}
                                                size={"small"}
                                                required={true}
                                                id="Name"
                                                label="Business Name"
                                                error={modalError.BusinessName}
                                                helperText={modalError.BusinessName ? "Business Name is required" : ""}
                                                variant="outlined"
                                                fullWidth={true}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey', // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",

                                                }}
                                            />
                                            <TextField
                                                size={"small"}
                                                id="BusinessType"
                                                select
                                                label="BusinessType"
                                                defaultValue={"individual"}
                                                value={businessType}
                                                onChange={handleChangeBusinessType}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey',
                                                            // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}
                                            >
                                                {BusinessTypeOptions.length > 0 ?
                                                    BusinessTypeOptions.map((option, index) => (
                                                        <MenuItem key={index} value={index}>
                                                            {option}
                                                        </MenuItem>
                                                    )) :
                                                    <MenuItem key="0" value={0}>
                                                        No Options Found
                                                    </MenuItem>
                                                }

                                            </TextField>

                                            <TextField
                                                onChange={handleChangeName}
                                                value={Name}
                                                size={"small"}
                                                required={true}
                                                id="Name"
                                                label="Name as per account"
                                                error={modalError.Name}
                                                helperText={modalError.Name ? "Name is required" : ""}
                                                variant="outlined"
                                                fullWidth={true}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey', // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}
                                            />

                                            <TextField
                                                value={bankAccountNumber}
                                                size="small"
                                                required
                                                id="Account-Number"
                                                placeholder={"Acc # min 9 digit"}
                                                error={modalError.bankAccountNumber}
                                                helperText={modalError.bankAccountNumber ? "Requires at least 9 Characters." : ""}
                                                label="Bank Account # "
                                                onChange={handleChangebankAccountNumber}
                                                variant="outlined"
                                                inputProps={{maxLength: 18}}
                                                fullWidth
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey', // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}


                                            />

                                            <TextField
                                                size={"small"}
                                                id="AccountType"
                                                select
                                                label="Account Type"
                                                defaultValue={"individual"}
                                                value={AccountType}
                                                onChange={handleChangeAccountType}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey', // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}
                                            >
                                                {AccountTypeOptions.length > 0 ?
                                                    AccountTypeOptions.map((option, index) => (
                                                        <MenuItem key={index} value={index}>
                                                            {option}
                                                        </MenuItem>
                                                    )) :
                                                    <MenuItem key="0" value={0}>
                                                        No Options Found
                                                    </MenuItem>
                                                }

                                            </TextField>

                                            <TextField
                                                value={IFSCCode}
                                                size="small"
                                                required
                                                id="IFSC"
                                                placeholder={"IFSC 11 chars e.g. SBIN0000738"}
                                                error={modalError.IFSCCode}
                                                helperText={modalError.IFSCCode ? "Requires at least 11 Characters." : ""}
                                                label="IFSC Code"
                                                onChange={handleChangeIFSCCode}
                                                variant="outlined"
                                                inputProps={{maxLength: 11}}
                                                fullWidth
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'// Default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey', // Border color on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue', // Border color when focused
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: '14px', sm: '14px' }, // Setting font size
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}


                                            />

                                            <TextField
                                                value={panNumber}
                                                size="small"
                                                required
                                                id="PAN"
                                                placeholder="ABCDE1234F"
                                                error={modalError.panNumber}
                                                helperText={modalError.panNumber ? "Invalid PAN Number format" : ""}
                                                label="PAN Number"
                                                onChange={handleChangePanNumber}
                                                variant="outlined"
                                                inputProps={{maxLength: 10}}
                                                fullWidth
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px'
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '14px',
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    fontSize: "1px",
                                                }}
                                            />

                                        </div>
                                    </Box>
                                </div>


                            </div>


                        </div>


                    </div>

                    <div className={"flex flex-col sm:flex-row gap-2 pt-3 sm:pt-4"}>
                        <button onClick={handleClose} disabled={isLoading}
                                className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                        </button>
                        <button
                            onClick={onSubmit} disabled={isLoading}
                            className={`w-full bg-cc_brand text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg border-gray-500 flex justify-center items-center text-xs sm:text-sm ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>
                            {isLoading && <CircularProgress sx={{color: "white"}} size={16} className="sm:w-5 sm:h-5"/>}
                            <p className={"ml-1.5 sm:ml-2"}>{isLoading ? "Loading" : "Add Bank Account"}</p>

                        </button>

                    </div>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}